import { TextControlProps } from "types";
import NumericControl from "../numeric-control/numeric-control";

type PhoneControlProps = Omit<TextControlProps, "type" | "pattern">;

const PhoneControl = (props: PhoneControlProps) => {
	const extendedProps = {
		...props,
		pattern: {
			value: /^(\d{10})$/,
			message: "Debes indicar un número de teléfono válido"
		}
	};

	return (
		<NumericControl {...extendedProps} format="## #### ####" placeholder={props.label} />
	);
};

export default PhoneControl;